import lazyScreen from '../utils/lazyScreen';
const INTCarrierMonitor = lazyScreen(() => import('../pages/carrier/INTCarrierMonitor/index.js'), 'pages/carrier/INTCarrierMonitor/index.js');

export default [
    { path: '/carrier/INTCarrierMonitor', component: INTCarrierMonitor },
    { path: '/carrier/INTCarrierOrders', component: INTCarrierMonitor },
    { path: '/carrier/INTCarrierEvents', component: INTCarrierMonitor },
    { path: '/carrier/INTCarrierJobQueues', component: INTCarrierMonitor }
];
